import { Box, Container, Typography } from '@mui/material';

export default function Footer() {
  return (
    <Box 
      component="footer" 
      className="footer"
      sx={{ 
        bgcolor: 'background.paper',
        color: 'text.primary'
      }}
    >
      <Container maxWidth={false} disableGutters>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Typography variant="body2">
            © 2025 EUDR API SERVICES. All rights reserved.
          </Typography>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <Typography variant="body2">
              Contact us: support@eudr-api.eu
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
} 